// Actions
import {
  SET_DATE_REGISTERED,
  SET_RELATIVE_ENGAGEMENT,
  SET_TOTAL_TIME_SPENT,
  SET_SCHEDULED_VISIT,
  SET_APPLIED,
  SET_ACTIVITY_WITH_INSTITUTION,
  SET_ACTIVITY_WITH_EAB,
  SET_ENGAGEMENT_STATE
} from "../actionTypes/engagement.actionTypes";

// Classes
import { EngagementReducerState } from "../classes/engagement.classes";

const initialState = new EngagementReducerState();

export const EngagementReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_DATE_REGISTERED:
      return { ...state, dateRegistered: action.payload };
    case SET_RELATIVE_ENGAGEMENT:
      return { ...state, relativeEngagement: action.payload };
    case SET_TOTAL_TIME_SPENT:
      return { ...state, totalTimeSpent: action.payload };
    case SET_SCHEDULED_VISIT:
      return { ...state, scheduledVisit: action.payload };
    case SET_APPLIED:
      return { ...state, applied: action.payload };
    case SET_ACTIVITY_WITH_INSTITUTION:
      return { ...state, activityWithInstitution: action.payload };
    case SET_ACTIVITY_WITH_EAB:
      return { ...state, activityWithEAB: action.payload };
    case SET_ENGAGEMENT_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
